import { FormInitialValues } from '../typings';
import { useFormValues } from '../core';

export const useNotApplicableField = (fieldId?: string) => {
  const values = useFormValues<FormInitialValues>();

  if (fieldId === undefined || values[fieldId] === undefined) {
    return false;
  }

  return values[fieldId] as boolean;
};
